// CreateUserDialog/index.js
import React from 'react';

import { userStatus } from '../../constants';
import CreateEditUserFormUI from '../CreateEditUserFormUI';

function CreateUserDialog(props) {
  const {
    openDialog,
    user,
    isSaving,
    openCreateUserDialog,
    onHandleInputChange,
    submitUser,
    branches,
    companies,
    fetchAllBranches,
    fetchAllCompanies,
    isLoadingBranches,
    isLoadingCompanies,
    loggedInUser
  } = props;

  React.useEffect(() => {
    if (branches && branches.length === 0 && openDialog) {
      fetchAllBranches();
      fetchAllCompanies();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDialog]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { user } = props;
    const payload = {
      ...user,
      status: userStatus.ACTIVE
    };
    submitUser(payload);
  };

  return (
    <React.Fragment>
      <CreateEditUserFormUI
        openDialog={openDialog}
        isSaving={isSaving}
        onHandleInputChange={onHandleInputChange}
        openCreateUserDialog={openCreateUserDialog}
        handleSubmit={handleSubmit}
        title="Create New User"
        user={user}
        branches={branches}
        companies={companies}
        isLoadingBranches={isLoadingBranches}
        isLoadingCompanies={isLoadingCompanies}
        creatingFromAdmin={true}
        loggedInUser={loggedInUser}
      />
    </React.Fragment>
  );
}

export default CreateUserDialog;
